export const enum BankOperationStatuses {
  Created = 'created',
  Reviewing = 'reviewing',
  Approved = 'approved',
  Canceled = 'canceled',
}
